export default __webpack_public_path__ + "static/media/scande.a2b78b5a.png";